export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 4_00.46d9c32e.jpg";